import { Wizard } from "@vwfs-bronson/bronson-react";

interface StepsWizardProps {
  activeStep: 1 | 2 | 3 | 4;
}

const STEP_LABELS = [
  "Confirmation de votre identité",
  "Confirmation de votre téléphone",
  "Régularisation attendue",
  // "Vos coordonnées", // DISABLED: billing address step removed from payment flow
  "Paiement",
];

const ARIA_LABELS = [
  "Étape 1 : Confirmation de votre identité",
  "Étape 2 : Confirmation de votre téléphone",
  "Étape 3 : Régularisation attendue",
  // "Étape 4 : Saisie de vos coordonnées", // DISABLED: billing address step removed from payment flow
  "Étape 4 : Paiement",
];

export const StepsWizard = ({ activeStep }: StepsWizardProps) => {
  const totalSteps = STEP_LABELS.length;
  const currentLabel = STEP_LABELS[activeStep - 1];
  const collapsedText = `Étape ${activeStep} sur ${totalSteps} - ${currentLabel}`;
  const navAriaLabel = `Étapes du formulaire - ${ARIA_LABELS[activeStep - 1]}`;

  return (
    <Wizard
      ariaLabel={navAriaLabel}
      collapseBreakpoint="m"
      collapsedText={collapsedText}
      stepLabels={{
        doneLabel: "complétée",
        errorLabel: "invalide",
        noInteractionLabel: "sans interaction",
        notDoneLabel: "à venir",
      }}
    >
      {STEP_LABELS.map((label, index) => {
        const step = index + 1;
        const isActive = step === activeStep;
        const isDone = step < activeStep;
        return (
          <Wizard.Item
            key={step}
            active={isActive}
            done={isDone}
            noInteraction
            aria-label={ARIA_LABELS[index]}
          >
            {label}
          </Wizard.Item>
        );
      })}
    </Wizard>
  );
};
